import {useEffect, useRef, useState} from 'react';
import {useParams} from 'react-router-dom';
import {observer} from 'mobx-react';
import {PageContainer} from '@vidazoo/ui-kit';
import useEditChartsManager from '../../../../common/hooks/useEditChartsManager';
import useReportingMetaDataManager from '../../../../common/hooks/useReportingMetaDataManager';
import useCloudManager from '../../../../common/hooks/useCloudManager';
import ChartDisplay from '../../../../common/components/chart-display/ChartDisplay';
import PageMessageLoader from '../../../../common/components/page-message-loader/PageMessageLoader';
import theme from './theme.module.scss';

// The shortcuts open the chart itself, without entering its editing form.
export default observer(function ChartView() {
    const {id} = useParams<{id: string}>();
    const cloud = useCloudManager();
    const lastTrackedChart = useRef<string>(null);
    useEffect(() => {
        if (!id || !cloud.isCloudReady || lastTrackedChart.current === id) return;
        lastTrackedChart.current = id;
        window.localStorage.setItem('lastChart', id);
        cloud.addTopCharts(id);
    }, [cloud, cloud.isCloudReady, id]);
    const charts = useEditChartsManager();
    const [error, setError] = useState(false);
    const model = charts.getModel(id);
    const {timePreset} = useReportingMetaDataManager();
    useEffect(() => {if (model) void model.getReport();}, [model, timePreset]);
    useEffect(() => {
        let mounted = true;
        setError(false);
        charts.initChartModel(id).catch(() => {if (mounted) setError(true);});
        return () => {mounted = false;};
    }, [charts, id]);
    if (error || model?.item.error) return <div role="alert">Could not load chart.</div>;
    if (!model || model.item.isLoading) return <PageMessageLoader title="Loading Chart" description="Please wait..."/>;
    return <PageContainer pageTitle={model.item.data?.name} top={1.2} className={theme.page}>
        <h1 className={theme.title}>{model.item.data?.name}</h1>
        <div className={theme.chart}>
            <ChartDisplay appearance="classic" showHeader={false} chartModel={model} isEditMode={false}/>
        </div>
    </PageContainer>;
});
